import React from 'react';

import { ToastContext } from '@utils/contexts/toasts';

export function withToast(Component) {
	return function ToastContextFn(props) {
		return (
			<ToastContext.Consumer>
				{notify => <Component {...props} notify={notify} />}
			</ToastContext.Consumer>
		);
	};
}
